const state = () => ({
    selectSurveyPrice: 0,
    selectSurveyName: 'Без съемки',
    id: null,
    block_dates: []
})

const mutations = {
    setSelectSurveyPrice(state, { price }) {
        state.selectSurveyPrice = price
    },
    setSelectSurveyName(state, { name, id }) {
        state.selectSurveyName = name
        state.id = id
    },
    setBlockDates(state, dates) {
        state.block_dates = dates
    }
}

const actions = {
    setSelectSurveyPrice({ commit }, { price }) {
        commit('setSelectSurveyPrice', { price })
    },
    setSelectSurveyName({ commit }, { name, id }) {
        commit('setSelectSurveyName', { name, id })
    },
    setBlockDates({ commit }, dates) {
        commit('setBlockDates', dates)
    },
}

const getters = {
    selectSurveyPrice: state => state.selectSurveyPrice,
    selectSurveyName: state => state.selectSurveyName,
    block_dates: state => state.block_dates,
    id: state => state.id
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};